import { Box, Chip, FormControl, FormHelperText } from "@mui/material";
import PropTypes from "prop-types";
import React from "react";
import { ReactMultiEmail } from "react-multi-email";
import "react-multi-email/dist/style.css";
import { convertToDefEventPara } from "../helper.js";

EMailInput.propTypes = {
  item: PropTypes.object.isRequired,
  value: PropTypes.any,
  error: PropTypes.string,
  onChange: PropTypes.func.isRequired,
  showErrorText: PropTypes.bool,
  variant: PropTypes.string,
  disabled: PropTypes.bool,
};

export default function EMailInput(props) {
  const {
    item,
    value,
    values,
    error = null,
    onChange,
    showErrorText = false,
    variant = "filled",
    disabled = false,
    size = "small",
  } = props;
  const [focused, setFocused] = React.useState(false);

  const handleOnChange = (newValue) => {
    if (item.write_label_to) {
      onChange([
        convertToDefEventPara(item.write_label_to, newValue?.label || null),
        convertToDefEventPara(item.name, newValue?.id || null),
      ]);
    } else {
      onChange(convertToDefEventPara(item.name, newValue || null));
    }
  };

  let helperText = "";
  if (showErrorText) {
    helperText = error;
  } else if (item.help) {
    helperText = item.help;
  }

  if (disabled) {
    return (
      <Box sx={{ display: "flex", gap: 2 }}>
        Weitere Empfänger:
        {value?.map((email, index) => (
          <Chip key={index} label={email}></Chip>
        ))}
      </Box>
    );
  } else
    return (
      <FormControl {...(error && { error: true })} style={{ width: "100%" }}>
        <ReactMultiEmail
          placeholder={item.label}
          emails={value || []}
          onChange={(newValue) => handleOnChange(newValue)}
          autoFocus={true}
          onFocus={() => setFocused(true)}
          onBlur={() => setFocused(false)}
          getLabel={(email, index, removeEmail) => {
            return (
              <div data-tag key={index}>
                <div data-tag-item>{email}</div>
                <span data-tag-handle onClick={() => removeEmail(index)}>
                  ×
                </span>
              </div>
            );
          }}
        />
        <FormHelperText>{helperText}</FormHelperText>
      </FormControl>
    );
}
